import React from "react";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';

import I18n from "../../../../base/i18n.js";

const blockStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.blueMain,
    fontSize: "38px",
    lineHeight: "50px",
    marginBottom: "5px",
    textTransform: "uppercase",
    textShadow: "0px 2px 6px rgba(0, 0, 0, 0.18)",
    ['@media (max-width: 768px)']: {
      fontSize: "18px",
      lineHeight: "26px",
      marginBottom: "10px",
      textShadow: "none"
    }
  },
}));

const Title = (props) => {
  const classes = blockStyles();

  const { className } = props;
  return (
    <div className = { clsx(classes.root, className) } >
      { I18n.t("web.page.profile.title") }
    </div>
  );
};

export default Title;
